import template from './agreements.html';
import controller from './agreements.controller';
import './agreements.styl';

const agreementsComponent = {
  template,
  controller,
  controllerAs: 'agreements',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

export default agreementsComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/agreements/agreements.component.js
 **/